import {
  Button,
  IconButton,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import React, { FC } from 'react';
import colors from '../../../../../themes/main-colors';
import { Close } from '@material-ui/icons';
import { useTranslation } from '../../../../../hooks/useTranslation';
import { Shadow } from '../../../../../constants/shadow';

type Props = {
  open: boolean;
  onClose: () => void;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalWrapper: {
      display: 'flex',
      width: '600px',
      maxHeight: '50vh',
      flexDirection: 'column',
      position: 'absolute',
      top: '50%',
      left: '50%',
      overflow: 'auto',
      transform: 'translate(-50%, -50%)',
      padding: theme.spacing(3.5, 3, 0.25, 3),
      backgroundColor: colors.modalBackgroundColor,
      borderRadius: '5px',
      [theme.breakpoints.down('sm')]: {
        top: '50%',
        width: '90%',
        maxHeight: '100%',
        padding: theme.spacing(3),
      },
    },
    closeButton: {
      position: 'absolute',
      top: 6,
      right: 24,
    },
    cancelButton: {
      width: '17%',
    },
    contactButton: {
      width: '13%',
    },
    safetyPriorityCallButton: {
      fontSize: '1rem',
      borderRadius: 5,
      color: colors.white,
      width: '130px',
      transform: 'translate(-50%)',
      background: colors.orange,
      letterSpacing: 0.32,
      boxShadow: `0px 5px 5px ${colors.boxShadowColor}`,
      '&:hover': {
        boxShadow: theme.shadows[5],
        background: colors.orange,
      },
    },
    dimOrFlickeringMessage: {
      background: colors.navBarBackground,
      padding: '0rem 1rem',
      boxShadow: Shadow.ONE,
      overflow: 'auto',
    },
    dimOrFlickeringMessageHeader: {
      marginBottom: '1rem',
    },
    dimOrFlickeringCloseButton: {
      width: '120px',
      color: colors.sparkBlue,
    },
    buttonContainer: {
      display: 'flex',
      padding: '1rem',
      width: '100%',
      justifyContent: 'space-evenly',
    },
    modalBody: {},
    kickerText: {
      paddingBottom: theme.spacing(1.875),
      paddingTop: theme.spacing(1.25),
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
      },
    },
  }),
);

const DimOrFlickering: FC<Props> = ({ onClose }) => {
  const classes = useStyles();
  const { t, richT } = useTranslation();
  const customerCareNumber = t('CUSTOMER_CARE_NUMBER_OTHER');

  return (
    <Modal
      open={true}
      onClose={onClose}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
    >
      <div className={classes.modalWrapper}>
        <div className={classes.closeButton}>
          <IconButton
            aria-label="close"
            color="inherit"
            onClick={onClose}
            data-testid="close-icon"
          >
            <Close />
          </IconButton>
        </div>
        <Typography
          variant={'h3'}
          className={classes.dimOrFlickeringMessageHeader}
        >
          {t('YOUR_SAFETY_IS_OUR_TOP_PRIORITY')}
        </Typography>
        <div className={classes.dimOrFlickeringMessage}>
          <Typography variant={'subtitle1'}>
            {richT('SAFETY_PRIORITY_MESSAGE')}
          </Typography>
        </div>
        <div className={classes.buttonContainer}>
          <div className={classes.cancelButton}>
            <Button
              className={classes.dimOrFlickeringCloseButton}
              onClick={onClose}
              style={{
                background: colors.white,
                border: `1.5px solid ${colors.sparkBlue}`,
              }}
            >
              {t('CLOSE')}
            </Button>
          </div>
          <div className={classes.contactButton}>
            <Button
              aria-label="checking-breaker-close"
              className={classes.safetyPriorityCallButton}
              onClick={onClose}
            >
              <Typography>
                {
                  <a
                    href={'tel:' + customerCareNumber}
                    style={{
                      textDecoration: 'none',
                      color: colors.white,
                      fontSize: 'smaller',
                    }}
                  >
                    {' '}
                    {customerCareNumber}
                  </a>
                }
              </Typography>
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DimOrFlickering;
